import React from "react";
import CompanyInformation from "../compony-information/CompanyInformation";
import TopProfessors from "../top-professors/TopProfessors";
import './InstitutionInformation.scss'

export default class InstitutionInformation extends React.PureComponent {
  render(): React.ReactNode {
    return (
      <>
        <div className="about-view-area">
          <CompanyInformation/>
          <TopProfessors/>
        </div>
      </>
    );
  }
}
